import { useEffect, useState } from "react";
import { onSnapshot, query, where } from "firebase/firestore";
import { fighterRequestsCollection } from "../utils/firebase";
import { fighterRequestStatus, fighterRequestType } from "../constants";

// Listens in real-time to the number of pending profile update requests
// (fighters who submitted an UPDATE_INFO request that is still PENDING).
export default function usePendingProfileUpdates() {
    const [count, setCount] = useState(0);

    useEffect(() => {
        const q = query(
            fighterRequestsCollection,
            where("status", "==", fighterRequestStatus.pending),
            where("type", "==", fighterRequestType.updateInfo)
        );

        const unsubscribe = onSnapshot(
            q,
            (snapshot) => setCount(snapshot.size),
            (error) => {
                console.error("Error watching pending profile updates: ", error);
            }
        );

        return () => unsubscribe();
    }, []);

    return count;
}
